import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { HttpErrorHandler } from "./http-error-handler";
import { Observable } from "rxjs";
import { NgResponse } from "../shared/ng-response";
import { NgRequest } from "../shared/ng-request";
import { FilterSortPageRequest, FilterValuesRequest, FilterValuesResponse } from "../shared/grid.model";
import { ViewRollupArtifactResponse } from "../shared/rollup-artifact.model";
import { ViewSubmissionArtifactResponse, ViewSubmissionArtifactsResponse } from "../shared/submission-artifact.model";
import { Request } from "../shared/base-artifact.model";

@Injectable()
export class DataService extends HttpClientService {
  constructor(readonly httpClient: HttpClient,
              readonly httpErrorHandler: HttpErrorHandler) {
    super('DataService', httpClient, httpErrorHandler);
  }

  fetchRollupArtifactItem(request: NgRequest<Request>): Observable<NgResponse<ViewRollupArtifactResponse>> {
    return this.postBody<Request, ViewRollupArtifactResponse>('fetchData', `api/RollupArtifact`, request);
  }

  fetchSubmissionArtifactItem(request: NgRequest<Request>): Observable<NgResponse<ViewSubmissionArtifactResponse>> {
    return this.postBody<Request, ViewSubmissionArtifactResponse>('fetchData', `api/SubmissionArtifact`, request);
  }

  fetchSubmissionArtifactItems(request: NgRequest<FilterSortPageRequest<Request>>): Observable<NgResponse<ViewSubmissionArtifactsResponse>> {
    return this.postBody<FilterSortPageRequest<Request>, ViewSubmissionArtifactsResponse>('fetchItems', `api/SubmissionArtifacts/Items`, request);
  }

  fetchSubmissionArtifactFilterValues(request: NgRequest<FilterValuesRequest<Request>>): Observable<NgResponse<FilterValuesResponse>> {
    return this.postBody<FilterValuesRequest<Request>, FilterValuesResponse>('fetchFilterValues', 'api/SubmissionArtifacts/FilterValues', request);
  }

  getSubmissionArtifactBlob(id: string): Observable<HttpResponse<Blob>> {
    return this.getBlobResponse('getBlob', `api/SubmissionArtifact/${id}/Blob`);
  }

  getRollupArtifactBlob(id: string): Observable<HttpResponse<Blob>> {
    return this.getBlobResponse('getBlob', `api/RollupArtifact/${id}/Blob`);
  }
}
